import { Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NLSTransaction } from 'src/app/model/NLSTransaction';
import { NLSTransactionService } from 'src/app/services/nls-transaction/nls-transaction.service';
import { AppConstants } from 'src/app/constants/app-constants';

@Component({
    selector: 'app-borrower-past-transactions-table',
    templateUrl: './borrower-past-transactions-table.component.html',
    styleUrl: './borrower-past-transactions-table.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BorrowerPastTransactionsTableComponent implements OnInit, OnDestroy {
    /** Dependency injections */
    private _nlsTransactionService = inject(NLSTransactionService);
    public transactionDetailsLink = AppConstants.MENU_TRANSACTION_DETAILS;

    /** Past transactions to render (current_balance = 0) */
    pastTransactions: NLSTransaction[] = [];

    /** Loading state */
    loading = true;

    /** Table columns */
    displayedColumns: string[] = [
        'transaction_id',
        'supplier_company',
        'last_update_date',
        'amount',
        'statusTitleCase',
        'current_balance',
    ];

    /** Subscription for data */
    private transactionEventsSub?: Subscription;

    /**
     * OnInit, subscribe to data changes and initialize data source
     */
    ngOnInit(): void {
        // Subscribe to transaction events
        this.transactionEventsSub = this._nlsTransactionService.changes$.subscribe((transactionEvents: NLSTransaction[]) => {
            // Filter for past transactions (current_balance = 0)
            this.pastTransactions = transactionEvents.filter(transaction => transaction.current_balance === 0);
            this.loading = false;
        });

        // Get latest data from nls transaction service
        const transactionEvents = this._nlsTransactionService.getEntities();
        if (transactionEvents) {
            this.pastTransactions = transactionEvents.filter((transaction: NLSTransaction) => transaction.current_balance === 0);
            this.loading = false;
        }
    }

    /**
     * On component destroy, unsubscribe from all subscriptions
     */
    ngOnDestroy(): void {
        if (this.transactionEventsSub) {
            this.transactionEventsSub.unsubscribe();
        }
    }

    /**
     * Format currency values
     * 
     * @param amount The amount to format
     * @return The formatted currency string
     */
    formatCurrency(amount: number): string {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    }

    /**
     * Format date values
     * 
     * @param date The date to format
     * @return The formatted date string
     */
    formatDate(date: Date | null): string {
        if (!date) return 'N/A';
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(new Date(date));
    }
}
